import classNames from 'classnames'

import { RCTooltip } from 'components/RCTooltip'

interface CustomChartLegendItemProps {
  legend: string
  inactive?: boolean
  markerWidth?: number
  markerHeight?: number
  markerColor?: string
  onClick?: () => void
}

export default function CustomChartLegendItem({
  legend,
  inactive,
  markerWidth,
  markerHeight,
  markerColor,
  onClick,
}: CustomChartLegendItemProps) {
  return (
    <RCTooltip tooltipMessage={legend}>
      <button className={classNames('CustomChartLegend-item', { inactive })} onClick={onClick} title={legend}>
        <div
          className="CustomChartLegend-item-icon"
          style={{
            width: markerWidth,
            height: markerHeight,
            backgroundColor: markerColor,
          }}
        />
        <p className="CustomChartLegend-item-text">{legend}</p>
      </button>
    </RCTooltip>
  )
}
